export const priceFormat = (price: number | null): string => {
  if (!price) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: price % 1 === 0 ? 0 : 2, // No decimals if it's a whole number
  }).format(price);
};
